/**************
 Mobile Nav
 ***************/

// mobile slider nested dropdown
document.querySelectorAll(".sliderNavDropdownToggle").forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("body").classList.add("noScroll");
}

// dialog close event
document.querySelector("#slider").addEventListener("close", async function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close nav
async function closeNav() {
    document.querySelector("#slider").close();
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});


// open / close header on scroll
let lastScrollY = window.scrollY;
let accumulatedScrollUp = 0;

window.addEventListener("scroll", function () {
    const currentScrollY = window.scrollY;
    const header = document.querySelector('#headerNav');

    // scrolling up
    if (currentScrollY < lastScrollY) {
        accumulatedScrollUp += (lastScrollY - currentScrollY);
        if (accumulatedScrollUp >= 50) {
            header.classList.add('active');
            accumulatedScrollUp = 0;
        }
    } else {
        // scrolling down
        accumulatedScrollUp = 0;
        if (currentScrollY > 50) {
            header.classList.remove('active');
        }
    }

    lastScrollY = currentScrollY;
});